export default function AnalyticsIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 16.125H16.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 11.625H13.5068M13.5 13.875H13.5068"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 13.875H4.50673M4.5 11.625H4.50673M4.5 9.375H4.50673M4.5 7.125H4.50673"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.84297 4.0439L12.1637 7.1928M6 3.375C6 4.20343 5.32843 4.875 4.5 4.875C3.67157 4.875 3 4.20343 3 3.375C3 2.54657 3.67157 1.875 4.5 1.875C5.32843 1.875 6 2.54657 6 3.375ZM15 7.875C15 8.70345 14.3284 9.375 13.5 9.375C12.6716 9.375 12 8.70345 12 7.875C12 7.04657 12.6716 6.375 13.5 6.375C14.3284 6.375 15 7.04657 15 7.875Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
